import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../authentication/auth-service';
import {NgClass} from '@angular/common';
import {LocalizationPipePipe} from '../../localization/control/localisation-pipe-pipe';
import {LanguageSelector} from '../../localization/boundary/language-selector/language-selector';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.html',
  standalone: true,
  imports: [
    NgClass,
    LocalizationPipePipe,
    LanguageSelector,
    RouterLinkActive,
    RouterLink
  ],
  styleUrl: './menu.scss'
})
export class Menu implements OnInit {
  protected isAuthenticated: boolean = false
  protected isAdjustor: boolean = false
  protected isFormManager: boolean = false
  protected isMenuOpen: boolean = false;
  protected isCreateClaimMenuOpen: boolean = false;

  constructor(private readonly authService: AuthService) {
  }

  ngOnInit(): void {
    this.authService.user$.subscribe(u => {
      if (u) {
        this.isAuthenticated = this.authService.isAuthenticated;
      } else {
        this.isAuthenticated = this.authService.isAuthenticated;
      }
      this.isAdjustor = this.isAuthenticated // && this.authService.userHasRole('adjustor')
      this.isFormManager = this.isAuthenticated && (this.authService.userHasRole('form-manager') || this.authService.userHasRole('insurance_company'))
    })
  }

  protected initiateLogin() {
    this.authService.login().then(r => console.log(r))
  }

  protected triggerLogout() {
    this.toggleMenu()
    this.authService.logout().then(r => console.log(r))
  }

  protected getUsername(): string | undefined {
    let profile = this.authService.getCurrentUser()?.profile;
    if (!profile) return undefined;
    return profile?.given_name + " " + profile?.family_name
  }

  protected onClickCreateClaimMenuOpen() {
    this.isCreateClaimMenuOpen = !this.isCreateClaimMenuOpen;
    this.toggleMenu();
  }

  protected toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

}
